import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { RootState } from 'handlers';
import Loader from 'components/Loader';
import { StepComponent } from 'components/Steps/stepUtils';
import useCurrentFlow from 'hooks/useCurrentFlow';
import FormNavigation from 'components/FormNavigation';
import { FormNavigationProps } from 'components/FormNavigation/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import { CheckingAccountResult } from 'enums/FlowNextResults';

import CheckingAccountsList from './components/BankAccountsList';

import styles from './SelectAccount.module.scss';

interface SelectAccountProps extends StepComponent {
  isAchUpdateFlow?: boolean;
  NavigationComponent?: React.ComponentType<FormNavigationProps>;
  navigationInfo?: FormNavigationProps;
  onBackClick?: () => void;
}

const SelectAccount = ({
  handleNext,
  isAchUpdateFlow = false,
  NavigationComponent = FormNavigation,
  navigationInfo,
  onBackClick,
}: SelectAccountProps) => {
  const { isMissedPaymentFlow } = useCurrentFlow();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { bankAccounts: checkingAccounts } = useSelector((state: RootState) => state.bankAccount)!;
  const { isLoading: isLoadingApplication } = useSelector((state: RootState) => state.applicationData!);
  const loadingNavigationProps =
    navigationInfo ||
    (isMissedPaymentFlow ? ({ showBackLink: false, title: 'Missed Payment' } as FormNavigationProps) : undefined);
  const contentNavigationProps =
    navigationInfo ||
    (isMissedPaymentFlow ? ({ title: 'Bank Account', step: 3, stepCount: 5 } as FormNavigationProps) : undefined);

  const handleContinue = () => {
    handleNext(CheckingAccountResult.Continue);
  };

  useEffect(() => {
    if (checkingAccounts.length > 0) {
      setIsLoading(false);

      // Skip checking account list if accounts are less than 2
      if (checkingAccounts.length < 2) {
        handleContinue();
      }
    }
  }, [checkingAccounts]);

  if (isLoading || isLoadingApplication) {
    return (
      <>
        {loadingNavigationProps && <NavigationComponent {...loadingNavigationProps} onBackClick={onBackClick} />}
        <FormContainer>
          <div className={styles.loaderContainer}>
            <Loader color="#795af7" />
          </div>
        </FormContainer>
      </>
    );
  }

  return (
    <>
      {contentNavigationProps && <NavigationComponent {...contentNavigationProps} onBackClick={onBackClick} />}
      <FormContainer
        title={isAchUpdateFlow ? 'Select your account' : 'Select the account where you deposit your paycheck'}
        subtitle={isAchUpdateFlow ? 'It will be used for your loan payments.' : undefined}
      >
        <CheckingAccountsList onContinue={handleContinue} />
      </FormContainer>
    </>
  );
};

export default SelectAccount;
